import { SpaceInfo } from "client/Api/Workspace/workspace";
import * as pubsub from "pubsub-js";

export enum WorkspaceEvent {
	SpaceAdded = "wrokspace.space.added",
	SpaceUpdated = "workspace.space.updated",
	SpaceDeleted = "workspace.space.deleted"
}

type Data<T extends WorkspaceEvent> =
	T extends WorkspaceEvent.SpaceAdded ? { space: SpaceInfo; } :
	T extends WorkspaceEvent.SpaceUpdated ? { space: SpaceInfo; } :
	T extends WorkspaceEvent.SpaceDeleted ? { spaceId: number; }:
	never;

export const subscribe: <T extends WorkspaceEvent>(kind: T, callback: (message: string, data: Data<T>) => void) => PubSubSubscriptionToken = pubsub.subscribe;
export const publish: <T extends WorkspaceEvent>(kind: T, data: Data<T>) => void = pubsub.publish;
export const unsubscribe: (token: PubSubSubscriptionToken) => void = pubsub.unsubscribe;